import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { Box, Button, Chip } from "@mui/material";
import GlobalDatagrid from "../../../../components/mui/DataGrid/GlobalDatagrid";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { LEAVE_GRANT_TABLE_HEAD } from "../../../../components/datagrid/leave/LeaveGrantTableHead";
import {
  getHrLeaveGrantApplications,
  getLeaveGrantRequests,
} from "../../../../redux/features/leaveSlice";
import ApproveLeaveGrant from "../../EmployeeServices/leave/ApproveLeaveGrant";

const HrLeaveGrantRequest = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { loading, hrapplications } = useSelector((state) => state.leave);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;
  const [action, setActionOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      ...LEAVE_GRANT_TABLE_HEAD,
      {
        field: "hod_status",
        minWidth: 150,
        headerName: "HOD Status",
        renderCell: (params) => {
            if (params.row.hod_status === 1) {
              return (
              <Chip
                label="Approved"
                color="success"
                size="medium"
                variant="outlined"
                />
              );
            } else if (params.row.hod_status === 2) {
              return (
              <Chip
                label="Rejected"
                color="error"
                size="medium"
                variant="outlined"
                />
              );
            } else {
              return (
              <Chip
                label="Pending"
                color="warning"
                size="medium"
                variant="outlined"
                />
            );
            }
      },
    },
    {
        field: "hr_status",
        minWidth: 150,
        headerName: "HR Status",
        renderCell: (params) => {
            if (params.row.hr_status === 1) {
              return (
              <Chip
                label="Approved"
                color="success"
                size="medium"
                variant="outlined"
                />
              );
            } else if (params.row.hr_status === 2) {
              return (
              <Chip
                label="Rejected"
                color="error"
                size="medium"
                variant="outlined"
                />
              );
            } else {
              return (
              <Chip
                label="Pending"
                color="warning"
                size="medium"
                variant="outlined"
                />
            );
            }
    }
      },
      {
        field: "Action",
        minWidth: 200,
        headerName: "Actions",
        renderCell: (params) => {
          return (
            <Button
              size="small"
              variant="contained"
              disabled={params.row.hod_status === 2}
              color="primary"
              startIcon={<Icon icon={"picon:plus"} width={18} height={18} />}
              onClick={() => {
                setSelectedRow(params.row);
                setActionOpen(true);
              }}
            >
              Action
            </Button>
          );
        },
      },
    ],
    [LEAVE_GRANT_TABLE_HEAD]
  );

  const data = {
    page: pageNum,
    limit: gridSize,
    search: search || "",
  };

  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getHrLeaveGrantApplications(data));
    }
  }, [pageNum, gridSize, search]);

  return (
    <GlobalWrapper title={"WFH Grant Approvals"}>
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={columns}
          rows={hrapplications?.data}
          meta={hrapplications?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={false}
        />
        {action && selectedRow && (
          <ApproveLeaveGrant
            open={action}
            setOpen={setActionOpen}
            row={selectedRow}
            dispatchData={data}
            Hr={true}
          />
        )}
      </Box>
    </GlobalWrapper>
  );
};

export default HrLeaveGrantRequest;
